__turbopack_context__.v({
  "Services": "Services-module__VF-7GG__Services",
  "logo": "Services-module__VF-7GG__logo",
  "name": "Services-module__VF-7GG__name",
  "tab": "Services-module__VF-7GG__tab",
  "tabs": "Services-module__VF-7GG__tabs",
});
